import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { page }  from '../class/status';
import { menulist }  from '../class/status';
import { environment } from '../../../environments/environment';
import * as moment from 'moment';
import { Dep } from '../class/auth';
import { chartdata }  from '../class/chatdata';
import * as Highcharts from 'highcharts';
import { Options } from "highcharts";



@Component({
  selector: 'app-stable',
  templateUrl: './stable.component.html',
  styleUrls: ['./stable.component.css']
})
export class StableComponent implements OnInit {
  Highcharts: typeof Highcharts = Highcharts;
  lineOptions:any = {...chartdata.line}
  lineOptions2:any = JSON.parse(JSON.stringify({...chartdata.line}));
  time :any={};
  tool_obj:any={sub_server_api:'1',sub_server_menu:'1',search_model:'',server_status:'-1',server_status2:'-1',tab_status:'-1',vpn_status:'-1',path_status:'-1',gender_action:'-1',process_list:[]}
  sort_obj:any = {column:'target_date',sort:'0'}
  data:any=[];
  top_info:any=[];
  time_info:any=-1;
  link:string = environment.link;
  edit_data:any=[]
  preurl :string = '';
  urltoken :string = '';
  updateFlag:boolean=false;
  datadetail = [];
  loading:boolean=true;
  pageobj:page = {page:0,count:12,total_count:0};
  pageobj1:page = {page:0,count:12,total_count:0};
  menu_list:menulist = [{id:'8',name:'api呼叫次數'},{id:'7',name:'WEB偵測用戶網路資訊'},{id:'5',name:'server_loading'},
    // {id:'6',name:'sql_process'},{id:'1',name:'api響應速度'},
    {id:'2',name:'server監控網路異常'},{id:'3',name:'用戶系統異常頻率'},{id:'4',name:'用戶網路異常資訊'}];
  pageobjstr:string=JSON.parse(JSON.stringify(this.pageobj))
  pageobjstr1:string=JSON.parse(JSON.stringify(this.pageobj))
  now:string = '8';
  ranges: any = {
    '今天': [moment(), moment()],
    '昨天': [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
    '過去一周': [moment().subtract(6, 'days'), moment()],
  }

  temitem = [];
  server_option_list:menulist=[
    {id:'-1',name:'全部'},
    {id:'4',name:'server:14'},
    {id:'3',name:'11F'},
  ];
  server_option_list2:menulist=[
    {id:'-1',name:'全部'},
    {id:'2',name:'正式api'},
    {id:'1',name:'正式DB'},
  ];

  tab_option_list:menulist=[
    {id:'-1',name:'全部'},
    {id:'0',name:'登入'},
    {id:'1',name:'探索頁'},
    {id:'2',name:'聊天頁'},
    {id:'3',name:'動態頁'},
    {id:'4',name:'約會頁'},
    {id:'5',name:'個人頁'},
  ];
  path_option_list:menulist=[
    {id:'-1',name:'全部'},
    {id:'1',name:'api'},
    {id:'2',name:'socket'},
  ];

  vpn_status_list:menulist=[
    {id:'-1',name:'全部'},
    {id:'0',name:'否'},
    {id:'1',name:'是'},
  ];


  tcontent =[
    {title:'名稱',content:'name',type:2},
    {title:'頭像',content:'profile_pic',type:1},
    {title:'性別',content:'gender',type:3},
    {title:'國家',content:'country'},
    {title:'城市',content:'city'},
    {title:'上傳',content:'upload',css:'min-width: 80px;',sort:'upload'},
    {title:'下載速度',content:'download',css:'min-width: 120px;',sort:'download'}, 
    {title:'是否有用vpn',content:'vpn',type:3}, 
    {title:'電信的hostname',content:'hostname',css:'min-width: 320px;'}, 
    {title:'os',content:'os'}, 
    {title:'ping值',content:'ping',css:'min-width: 100px;',sort:'ping'}, 
    {title:'花多少時間(m/s)',content:'used_time',css:'min-width: 200px;',sort:'used_time'}, 
    {title:'建立時間',content:'create_dt'}, 
    {title:'操作',content:'gg',type:3}, 
  ];

  tcontentdetail =[
    {title:'日期',content:'traceDate'},
    {title:'路徑',content:'tracePath'},
    {title:'連結',content:'traceInfos',type:3},
  ];


  constructor(
    public httpClient: HttpClient,
  ) { }

  ngOnInit(): void {
    this.preurl = environment.serverurl;
    this.urltoken = this.preurl+"/v1/common/get_server_slow_log_detail.php?limit=true&token="+Dep.token+"&time="+Date.now();  
    this.init_time();
  }

  click(item){
   
     // 將 item 轉換成查詢字符串
    const queryString = encodeURIComponent(JSON.stringify(item));

    // 建立新的 URL
    const url = this.preurl+"/v1/common/show_url.php?limit=true&token="+Dep.token+"&time="+Date.now()+`&data=${queryString}`;
    // 打開新頁面
    window.open(url, '_blank');
  }

  checklist(item){
    this.temitem = item;
    this.loading = true;
    const body = {spe:1,page: this.pageobj1.page,count:this.pageobj1.count,action:this.now,now_range:this.time,tool:this.tool_obj,sort_obj:this.sort_obj,item:this.temitem};
    this.httpClient.post<any>("/v1/common/get_stable_list.php",body).subscribe(res => {
        this.loading = false;

        if(res.data?.length > 0){
            this.datadetail = res.data;
            this.pageobj1.total_count = res.total_count
            this.pageobjstr1=JSON.parse(JSON.stringify(this.pageobj1))
        }
       
    }, error => {
      console.log(error);
    });



    console.log(item);
  }

  handlesortdata( value: any ): void {
    this.pageobj = {page:0,count:12,total_count:0};
    this.sort_obj = value;
    this.init_list(); 
 }

  init_time(){
    this.time.minDate = moment().subtract(7, 'days')
    this.time.maxDate = moment().subtract(0, 'days')

    let default_status = true;
    if(this.time_info!=-1){
      const tmp = this.time_info.split("_");
      if(tmp.length==4){
        default_status = false;
        this.time.start = tmp[0]
        this.time.end = tmp[1]

  
        this.time.startDate = moment(tmp[0]);
        this.time.endDate = moment(tmp[1]);
    
      }
    }
    
    if(default_status){
      this.time.startDate = moment().subtract(1, 'days');
      this.time.endDate = moment().subtract(0, 'days');
      this.time.start = moment(this.time.startDate)
      this.time.end = moment(this.time.endDate)
    }


    this.init_list();  
  }

  init_list(){

    console.log(this.now,this.sort_obj.column);
    this.loading = true;
    const body = {page: this.pageobj.page,count:this.pageobj.count,action:this.now,now_range:this.time,tool:this.tool_obj,sort_obj:this.sort_obj};
    this.httpClient.post<any>("/v1/common/get_stable_list.php",body).subscribe(res => {
      this.loading = false;

      if(res.data?.length > 0){
        this.data = res.data
      }
      this.top_info = res.top_info
      this.pageobj.total_count = res.total_count
      if(res.status && (this.now=='5'||this.now=='6')){
        this.draw_chat(res.top_info,this.now)
       
      }

    if(this.now == '8'){
        this.draw_chat(res,this.now)
    }

      this.pageobjstr=JSON.parse(JSON.stringify(this.pageobj))
    }, error => {
      console.log(error);
    });
  }

  callback(pageobj:page){
    if(JSON.stringify(this.pageobj)!=JSON.stringify(pageobj)){
      this.pageobj = pageobj;
      this.init_list();
    }
  }

  callback1(pageobj:page){
    if(JSON.stringify(this.pageobj1)!=JSON.stringify(pageobj)){
      this.pageobj1 = pageobj;
      this.checklist(this.temitem);
    }
  }

  onDateTyped(event: any) {
    const val = (event && event.target && event.target.value) ? String(event.target.value) : '';
    if (!val) { return; }
    const parts = val.split(' - ');
    if (parts.length !== 2) { return; }
    let s = moment(parts[0].trim(), 'YYYY-MM-DD', true);
    let e = moment(parts[1].trim(), 'YYYY-MM-DD', true);
    if (!s.isValid() || !e.isValid()) { return; }
    if (s.isAfter(e)) { const t = s; s = e; e = t; }
    // 冪等：與目前範圍相同就不重複觸發（避免點選後 blur 又重查一次）
    if (this.time && this.time.start === s.format('YYYY-MM-DD') && this.time.end === e.format('YYYY-MM-DD')) { return; }
    this.onRangeSelected(1, { startDate: s, endDate: e });
  }

  onRangeSelected(type,value: any) {
    if(value.startDate){
      this.time.start =  moment(value.startDate).format('YYYY-MM-DD')
      this.time.end =  moment(value.endDate).format('YYYY-MM-DD')
      this.init_list();  
    }
  }

  choose(value:string){
    this.now = value;

    if(this.now=='1'){
      this.sort_obj.column =  'target_date'
    }else{
      this.sort_obj.column =  'create_dt'
    }

    if(this.now=='7'){
        this.sort_obj.column = 'id'
    }

    this.pageobj.page = 0;
    this.init_list();
  }

  draw_chat(para,action){

    if(action == 5){
      this.lineOptions.title.text = '';
      this.lineOptions.subtitle.text = '';
      let series = [];
      for(let i in para.data.loader_info){
          series.push(para.data.loader_info[i]);
      }
      this.lineOptions.chart.zoomType = 'x';
      this.lineOptions.series = series;
      this.lineOptions.xAxis = {categories: para.data.categories };
      this.lineOptions.yAxis.plotLines = [
        {
          value: 5, // 警戒線的位置，這裡假設為 3
          color: 'red', // 警戒線的顏色
          width: 2, // 警戒線的寬度
          zIndex: 5, // 警戒線的層級
          label: {
            text: '警戒線', // 警戒線的標籤文字
            align: 'right', // 標籤文字對齊方式
            style: {
              color: 'gray' // 標籤文字的樣式
            }
          }
        }
      ];
      this.updateFlag = true;
      let series2 = [];
      for(let i in para.data.ram_used){
        series2.push(para.data.ram_used[i]);
      }
  
      // this.lineOptions2.chart.zoomType = 'x';
      this.lineOptions2.title.text = '';
      this.lineOptions2.subtitle.text = '';
      this.lineOptions2.series = series2;
      this.lineOptions2.xAxis = {categories: para.data.categories };
      this.lineOptions2.yAxis.plotLines = [
        {
          value: 75, // 警戒線的位置，這裡假設為 3
          color: 'red', // 警戒線的顏色
          width: 2, // 警戒線的寬度
          zIndex: 5, // 警戒線的層級
          label: {
            text: '警戒線', // 警戒線的標籤文字
            align: 'right', // 標籤文字對齊方式
            style: {
              color: 'gray' // 標籤文字的樣式
            }
          }
        }
      ];
      this.updateFlag = true;
    }else if(action == 8){

        const apiTitleMap = {
            '1': 'API呼叫次數折線圖(日)',
            '2': 'API呼叫次數折線圖(時)',
            '3': 'API呼叫次數折線圖(分)',
        };
        
        const titleText = apiTitleMap[this.tool_obj.sub_server_api];
        this.lineOptions.title.text = titleText;
     
        this.lineOptions.xAxis = { categories: para.categories };
        this.lineOptions.series = [para.data];
        this.lineOptions.yAxis.plotLines = [];
        this.updateFlag = true;

    }else{
      this.lineOptions.title.text = '';
      this.lineOptions.subtitle.text = '';
      let series = [];
      for(let i in para.data.loader_info){
          series.push(para.data.loader_info[i]);
      }
      this.lineOptions.chart.zoomType = 'x';
      this.lineOptions.series = series;
      this.lineOptions.xAxis = {categories: para.data.categories };
      this.lineOptions.yAxis.plotLines = [
        {
          value: 1800000, // 警戒線的位置，這裡假設為 3
          color: 'red', // 警戒線的顏色
          width: 2, // 警戒線的寬度
          zIndex: 5, // 警戒線的層級
          label: {
            text: '警戒線', // 警戒線的標籤文字
            align: 'right', // 標籤文字對齊方式
            style: {
              color: 'gray' // 標籤文字的樣式
            }
          }
        }
      ];
      this.updateFlag = true;
     
    }
    console.log(this.lineOptions);

  }

  sort_fn(key,can_sort=1){
    if(can_sort){
      if(key==this.sort_obj.column){
        this.sort_obj.sort = this.sort_obj.sort == '0'?'1':'0';
      }else{
        this.sort_obj.column = key;
        this.sort_obj.sort = '0';
      }
      this.init_list(); 
    }

  }

}
